import './styles/main.css';
import { AppController } from './app/app-controller';
import { validateShippedContent } from './data/validate-content';

const app = document.querySelector<HTMLElement>('#app');
if (!app) throw new Error('Missing application host.');
try {
  validateShippedContent();
  new AppController(app).start();
} catch (error) {
  console.error('Hyperwar RTS fatal startup error:', error);
  const detail = error instanceof Error ? error.message : 'Unknown startup error.';
  app.innerHTML = `<div class="menu-shell"><section class="hero"><p class="eyebrow">FATAL ERROR</p><h1>Unable to boot</h1><p>${detail}</p><p class="hint">Check the browser console for diagnostic details.</p></section></div>`;
}
